
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  document.querySelectorAll(".related-product-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  document.querySelectorAll(".pdp-main-wrapper").forEach(function (card) {
    productDataUpdate(card, true);
  });
  document.querySelectorAll(".custom-pdp-two-col-section:not(.new-pdp-layout-section)").forEach(function (card) {
    productDataUpdate(card, true);
  });
  document.querySelectorAll(".product-card-wrapper").forEach(function (card) {
    productDataUpdate(card, false);
  });
});

function productDataUpdate(card, isPDP){
  let buttons = card.querySelectorAll(".product-selector-color");
  if (buttons.length === 0) {
    buttons = card.querySelectorAll(".product-selector-options");
  }
  const imageEl = card.querySelector("[data-product-image]");
  const priceEl = card.querySelector("[data-actual-price]");
  const comparePriceEl = card.querySelector("[data-compare-price]");
  const pdpImageEls = card.querySelectorAll(".pdp-image-video-wrap");
  const buyButtonEl = card.querySelector("[data-buyButton]");
  const cardAnchorEls = card.querySelectorAll("a[data-product-url]");
  const productInfoTextEl = card.querySelector(".product-details .product-info-text[data-product-info]");

  const addToCartText = card.getAttribute("data-addToCartText");
  const soldOutText = card.getAttribute("data-soldOutText");
  
  buttons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      // Remove active class
      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
  
      const productId = btn.getAttribute("data-product-id");
      const variantId = btn.getAttribute("data-variant-id");
      const img = btn.getAttribute("data-image");
      const price = btn.getAttribute("data-price");
      const compareAtPrice = btn.getAttribute("data-compare-at-price");
      const availability = btn.getAttribute("data-availability");
      const variantURL = btn.getAttribute("data-url");
      const product_color = btn.getAttribute("data-color");
      const isComingSoon = btn.getAttribute("data-coming-soon")=='true';
      const isPreorder = btn.getAttribute("data-is-preorder") === "true";
  
      const rawPrice = btn.getAttribute("data-raw-price");
      const rawCompareAtPrice = btn.getAttribute("data-raw-compare-at-price");
      const formatRawPrice = Number(rawPrice)
      const formatRawCompareAtPrice = Number(rawCompareAtPrice)
      const savePrice = formatRawCompareAtPrice - formatRawPrice;

      // Update image
      if(isPDP){
        if(pdpImageEls){
          const btnDataLink = btn.getAttribute("data-link");
          pdpImageEls.forEach(el => {
            if (el.getAttribute("data-id") === btnDataLink) {
              el.classList.add("active");
            } else {
              el.classList.remove("active");
            }
          });
        }

        const colorText = document.querySelector(".color-text");
    
        if (colorText) {
            colorText.textContent = product_color;
        }
        if (product_color){
           const variantGalleryImages = document.querySelectorAll('.variant-color-image-'+product_color);
           if (variantGalleryImages.length > 0) {
              $('.variant-gallery-images').hide();
               variantGalleryImages.forEach(el => {
                el.style.display = 'block';
              });
           }
        }
                
        
        // Update for PDP Top sticky bar start
        const pdpTopBarEl = document.querySelector(".pdp-top-sticky-bar");
        
        if (pdpTopBarEl) {
          const pdpTopBuyButtonEl = pdpTopBarEl.querySelector("[data-buyButton]");
          const pdpTopBuyButtonTextEls = pdpTopBuyButtonEl?.querySelectorAll("[data-buyButtonText]");
          const actualPriceEl = pdpTopBarEl.querySelector("[data-actual-price]");
          const comparePriceEle = pdpTopBarEl.querySelector("[data-compare-price]");
        
          if (pdpTopBuyButtonEl && pdpTopBuyButtonTextEls && !isComingSoon) {
            if (availability === 'true' || availability === true) {
              pdpTopBuyButtonTextEls.forEach(el => {
                //el.textContent = addToCartText || "Buy now";
                el.textContent = isPreorder ? "Preorder" : (addToCartText || "Buy now");
              });
              pdpTopBuyButtonEl.removeAttribute("disabled");
            } else {
              pdpTopBuyButtonTextEls.forEach(el => {
                el.textContent = soldOutText || "Not available";
              });
              pdpTopBuyButtonEl.setAttribute("disabled", "");
            }
          }
        
          if (actualPriceEl) {
            actualPriceEl.textContent = price;
          }
        
          if (comparePriceEle) {
            if (compareAtPrice && savePrice > 0) {
              comparePriceEle.style.display = 'inline-block';
              comparePriceEle.textContent = compareAtPrice;
            } else {
              comparePriceEle.style.display = 'none';
            }
          }
        }
        //end
        
        document.querySelectorAll('.form-variant-id-' + productId).forEach(el => {
          el.value = variantId;
        });

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', variantId);

        // Update URL without page reload
        window.history.replaceState({}, '', newUrl);
      }else{
        //document.querySelector('.form-variant-id-'+productId).value = variantId;
        const input = document.querySelector('.form-variant-id-' + productId);
        if (input) {
          input.value = variantId;
        } else {
          console.warn('No element found with class: .form-variant-id-' + productId);
        }
        
        if (img && imageEl) {
          imageEl.src = img;
        }

        //Update variant url 
        cardAnchorEls.forEach(el => {
          el.href = variantURL;
        });
        
      }

      // Update addtocart button text
      if(buyButtonEl && !isComingSoon){
          const buttonTextEls = buyButtonEl.querySelectorAll("[data-buyButtonText]");
          
          if (availability === 'true' || availability === true) {
            buttonTextEls.forEach(el => {
              //el.textContent = addToCartText || "Buy now";
              el.textContent = isPreorder ? "Preorder" : (addToCartText || "Buy now");
            });
            buyButtonEl.removeAttribute("disabled");
            if(productInfoTextEl) {
              productInfoTextEl.style.display = 'none';
            }
          } else {
            buttonTextEls.forEach(el => {
              el.textContent = soldOutText || "Not available";
            });
            buyButtonEl.setAttribute("disabled", "");
            if(productInfoTextEl) {
              productInfoTextEl.style.display = 'block';
            }
          }
      }
  
      // Update actual price
      if (priceEl) {
        priceEl.textContent = price;
      }
  
      // Update compare at price (or hide if not applicable)
      if (comparePriceEl) {
        if (compareAtPrice && savePrice > 0) {
          comparePriceEl.style.display = 'inline-block';
          comparePriceEl.textContent = compareAtPrice;
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
    });
  });
}  

/** Menu hover image start */
let lastBannerKey = null;

function getMenuBannerURL(newButtonURL) {
  if (!newButtonURL || newButtonURL.startsWith('http')) {
    return newButtonURL;
  }

  let finalURL = newButtonURL;
  if (window.Weglot) {
    const currentLanguage = Weglot.getCurrentLang();
    const langPrefix = `/${currentLanguage}`;

    if (currentLanguage !== "en" && !newButtonURL.startsWith(langPrefix)) {
      finalURL = `${langPrefix}${newButtonURL}`;
    }
  }
  return finalURL;
}

function getTodayStore() {
  if (!window.storeNow || !window.storeOffset) {
    return null;
  }

  const offset = window.storeOffset;
  const sign = offset[0] === "-" ? -1 : 1;
  const hours = parseInt(offset.slice(1, 3), 10);
  const minutes = parseInt(offset.slice(3, 5), 10);

  const offsetMs = sign * ((hours * 60 + minutes) * 60000);

  const utc = window.storeNow * 1000;
  const storeTime = new Date(utc + offsetMs);

  return `${storeTime.getUTCFullYear()}-${String(storeTime.getUTCMonth() + 1).padStart(2, "0")}-${String(storeTime.getUTCDate()).padStart(2, "0")}`;
}

function getGlobalPromoBanner() {
  const el = document.getElementById("global-promo-banner-data");

  if (!el || el.dataset.enabled !== "true") {
    return null;
  }

  const today = getTodayStore();

  if (!today) {
    return null;
  }

  const start = el.dataset.start;
  const end = el.dataset.end;

  if ((start && today < start) || (end && today > end)) {
    return null;
  }

  return {
    heading: el.dataset.heading,
    description: el.dataset.description,
    buttonLabel: el.dataset.buttonLabel,
    buttonURL: el.dataset.buttonUrl,
    image: el.dataset.image
  };
}

function applyBannerData(mainMenuId, data) {
  const key = JSON.stringify({ mainMenuId, ...data });

  if (lastBannerKey === key) return;
  lastBannerKey = key;

  const $button = $("#hover-button-" + mainMenuId);
  const $heading = $("#hover-heading-" + mainMenuId);
  const $description = $("#hover-description-" + mainMenuId);
  const $image = $("#hover-image-" + mainMenuId);

  $heading.text(data.heading || "");
  $description.text(data.description || "");

  if (data.buttonLabel && data.buttonURL) {
    const finalURL = getMenuBannerURL(data.buttonURL);
    $button
      .text(data.buttonLabel)
      .attr("href", finalURL)
      .css("visibility", "visible");
  } else {
    $button.css("visibility", "hidden");
  }

  if (data.image && $image.attr("src") !== data.image) {
    $image.attr("src", data.image);
  }
}

function setupMenuHoverEvents() {
    $(".mega-menu-links-col a").off("click");

    $(document).on(
        "mouseenter",
        ".main-nav-list a, .mega-menu-links-col a",
        function () {
            if (window.innerWidth <= 1023) return;

            const $this = $(this);
            const mainMenuId = $this.data("id");
            if (!mainMenuId) return;

            const banner = getGlobalPromoBanner();

            if (banner) {
                applyBannerData(mainMenuId, banner);
                return;
            }

            const isMainNav = $this.closest(".main-nav-list").length > 0;
            const isSubMenu = $this.closest(".mega-menu-links-col").length > 0;

            const $mainMenu = $(`.main-nav-list a[data-id="${mainMenuId}"]`);

            const mainData = {
                image: $mainMenu.data("image"),
                heading: $mainMenu.data("heading"),
                description: $mainMenu.data("description"),
                buttonLabel: $mainMenu.data("button-label"),
                buttonURL: $mainMenu.data("button-url"),
            };

            const hasMainBanner =
                mainData.image ||
                mainData.heading ||
                mainData.description ||
                mainData.buttonLabel ||
                mainData.buttonURL;

            if (hasMainBanner) {
                applyBannerData(mainMenuId, mainData);
                return;
            }

            if (isMainNav) {
                return;
            }

            if (isSubMenu) {
                const data = {
                    image: $this.data("image"),
                    heading: "",
                    description: "",
                    buttonLabel: "",
                    buttonURL: "",
                };

                if (!data.image) return;

                applyBannerData(mainMenuId, data);
            }
        }
    );
}

$(document).ready(setupMenuHoverEvents);
/*** Menu hover image end **/

$(document).ready(function () {
  $(".shopping-btn").on("click", function () {
    const cartDrawerCloseBtn = $(".cart-drawer__close-button");
    if (cartDrawerCloseBtn.length) {
      setTimeout(() => {
        cartDrawerCloseBtn.trigger("click");
      }, 300);
    }
  });

   // Close cart drawer when clicking outside it (on body)
    //$(document).on("click", function (e) {
    $(".cart-drawer .cart-overlay").on("click", function (e) {
      console.log("body click");
      const $cartDrawer = $(".cart-drawer");
      const $closeBtn = $(".cart-drawer__close-button");
  
      $closeBtn.trigger("click");
    });

  // Prevent body click from closing drawer when clicking inside it
  $(".cart-drawer").on("click", function (e) {
    e.stopPropagation();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.quantity-select').forEach(function (selectEl) {
    selectEl.addEventListener('change', function (event) {
      const quantity = event.target.value;
      const dataId = selectEl.dataset.id;

      const quantityWrapper = selectEl.closest('.cart-item')?.querySelector('quantity-selector-component');

      if (!quantityWrapper) return;
      const inputEl = quantityWrapper.querySelector('.quantity_input'+dataId);
      if (!inputEl) return;
  
      inputEl.value = quantity;
      inputEl.dispatchEvent(new Event('blur', { bubbles: true }));
    });
  });
});

document.addEventListener('change', function(event) {
  if (event.target.matches('.quantity-select')) {
  
    const selectEl = event.target;
    const quantity = selectEl.value;
    const dataId = selectEl.dataset.id;

    const quantityWrapper = selectEl.closest('.cart-item')?.querySelector('quantity-selector-component');

    const inputEl = quantityWrapper.querySelector('.quantity_input' + dataId);
    if (!inputEl) return;

    inputEl.value = quantity;
    inputEl.dispatchEvent(new Event('blur', { bubbles: true }));
  }
});

$(document).ready(function () {
  const currentUrl = window.location.pathname;
  $(".inner-page-navbar ul li a").removeClass("active");
  $(".inner-page-navbar ul li a").each(function () {
    const linkHref = $(this).attr("href");
    // console.log(linkHref + ' '+ currentUrl);
    // Skip empty href or just "#"
    if (!linkHref || linkHref === "#") return;

    // Add active only if URL matches exactly or contains the path
    if (currentUrl.indexOf(linkHref) !== -1 && linkHref !== "/") {
      $(this).addClass("active");
    }
  });
});

/** Start Blog page menu filters **/
document.addEventListener('DOMContentLoaded', function () {
  const currentUrl = window.location.href;
  const tabLinks = document.querySelectorAll('.blog-listing-filter ul li a');

  tabLinks.forEach(function (link) {
    const linkHref = link.getAttribute('href');
    if (currentUrl.includes(linkHref) && linkHref.includes('/tagged/')) {
      document.querySelectorAll('.blog-listing-filter ul li').forEach(el => el.classList.remove('current'));
      link.closest('li').classList.add('current');
    }
  });
});
/** End Blog page menu filters **/


document.addEventListener("DOMContentLoaded", function () {
  const tocList = document.querySelector('.top-content .sidebar');
  const article = document.querySelector('.article-template');

  if (!tocList || !article) return;

  const headings = article.querySelectorAll('h2.scroll-section, h3.scroll-section');


  function generateId(text) {
    // Only take first part before comma (if any)
    let baseText = text.split(',')[0];
    return baseText
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')        // Remove punctuation
      .replace(/\s+/g, '-')            // Replace spaces with hyphens
      .replace(/-+/g, '-');            // Remove repeated dashes
  }

  const usedIds = new Set();

  headings.forEach((heading, index) => {
    let id = generateId(heading.textContent);

    // Ensure unique ID if duplicate exists
    let uniqueId = id;
    let suffix = 1;
    while (usedIds.has(uniqueId)) {
      uniqueId = `${id}-${suffix++}`;
    }
    usedIds.add(uniqueId);

    heading.setAttribute('id', uniqueId);

    const li = document.createElement('li');
    li.setAttribute('data-target', `#${uniqueId}`);
    if (index === 0) li.classList.add('active-slide');

    const button = document.createElement('button');
    button.textContent = heading.textContent;

    li.appendChild(button);
    tocList.appendChild(li);
  });

  // Scroll and set active class
  document.querySelectorAll('.toc-list li button').forEach(btn => {
    btn.addEventListener('click', function () {
      const targetId = this.parentElement.getAttribute('data-target');
      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Update active-slide
      document.querySelectorAll('.toc-list li').forEach(li => li.classList.remove('active-slide'));
      this.parentElement.classList.add('active-slide');
    });
  });
});


/*** Collection List Start ****/
function applyFilters() {
  console.log("applyFilters");

  const selectedColors = [...document.querySelectorAll('.filter-color:checked')].map(el => el.value.toLowerCase());
  const selectedCategories = [...document.querySelectorAll('.filter-category:checked')].map(el => el.value.toLowerCase());
  const selectedFeatures = [...document.querySelectorAll('.filter-feature:checked')].map(el => el.value.toLowerCase());

  let visibleCount = 0;
  console.log(selectedColors);

  document.querySelectorAll('.product-list-card.collection_page').forEach(card => {
    const productTags = (card.dataset.tags || '')
      .split(',')
      .map(tag => tag.trim().toLowerCase());

    const productColor = (card.dataset.color || '')
      .split(',')
      .map(color => color.trim().toLowerCase());

    const title = card.dataset.title || 'No Title';

    const categoryTagMatch = selectedCategories.length === 0 ||
      selectedCategories.some(cat => productTags.includes(`category-${cat}`));

    const colorMatch = selectedColors.length === 0 ||
      selectedColors.some(color => productColor.includes(color));

    const featuresTagMatch = selectedFeatures.length === 0 ||
      selectedFeatures.some(feature => productTags.includes(`feature-${feature}`));

      console.log(colorMatch+ title);

    const isVisible = categoryTagMatch && colorMatch && featuresTagMatch;

    if (isVisible) {
      card.style.display = 'block';
      visibleCount++;  
    } else {
      card.style.display = 'none';
    }
  });

  const countElement = document.getElementById('filter-result-count');
  if (countElement) {
    countElement.textContent = `${visibleCount} Product${visibleCount !== 1 ? 's' : ''}`;
  }

}
const applyFiltersButton = document.getElementById("apply-filters");
if (applyFiltersButton) {
  applyFiltersButton.addEventListener("click", applyFilters);
}



/*document.getElementById('custom-filters').addEventListener('submit', function (e) {
  console.log("submit");
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);
  const params = new URLSearchParams();
console.log("params "+params);
  for (const [key, value] of formData.entries()) {
    params.append(key, value);
  }

  const collectionUrl = window.location.pathname;
  const filterUrl = `${collectionUrl}?${params.toString()}`;
  console.log(filterUrl);
  filterCollectionList(filterUrl);
  
});*/

document.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((radio) => {
  radio.addEventListener('change', function () {
    const selectedValue = this.value;
    console.log('Selected sort option:', selectedValue);

    const collectionUrl = window.location.pathname;
    const filterUrl = `${collectionUrl}?sort_by=${selectedValue}`;

    filterCollectionList(filterUrl);
    document.querySelector(".sort-by-filter").textContent = this.dataset.sortby;
  });
});

function contentanimationForAjax() {
  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $(entry.target).addClass("content-animate");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.05,
    }
  );
  $(".content-visible").each(function () {
    observer.observe(this);
  });
}


function filterCollectionList(filterUrl){
  fetch(filterUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newProducts = doc.querySelector('#filtered-products');
      document.getElementById('filtered-products').innerHTML = newProducts.innerHTML;

      //applyFilters();
       const selectedColors = [...document.querySelectorAll('.filter-color:checked')].map(el => el.value.toLowerCase());
      const selectedCategories = [...document.querySelectorAll('.filter-category:checked')].map(el => el.value.toLowerCase());
      const selectedFeatures = [...document.querySelectorAll('.filter-feature:checked')].map(el => el.value.toLowerCase());
      
      console.log(selectedColors + selectedCategories);

      const count = document.querySelectorAll('#filtered-products li').length;
      document.querySelector('#filter-result-count').textContent = count+' Products';

      applyFilters();

      contentanimationForAjax();
      // Re-initialize
      document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
        productDataUpdate(card, false);
      });
    });
}


function updateFilterCounts() {
  const checkboxes = document.querySelectorAll('.filter-checkbox-input');
  const counts = {};
  let anyChecked = false;

  checkboxes.forEach(cb => {
    if (cb.checked) {
      anyChecked = true;
      const type = cb.dataset.filtertype;
      counts[type] = (counts[type] || 0) + 1;
    }
  });

  const filterTypes = ['color', 'category', 'feature'];
  filterTypes.forEach(type => {
    // Support both desktop and mobile badges
    const badgeTypes = document.querySelectorAll(`.${type}-filter-badge`);
    badgeTypes.forEach(badgeType => {
      badgeType.style.display = counts[type] ? 'inline-flex' : 'none';
    });

    const badges = document.querySelectorAll(`#${type}-filter-badge-count`);
    badges.forEach(badge => {
      badge.textContent = counts[type] || 0;
    });
  });

  const sortTab = document.querySelector('.sort-by-tab');
  if (sortTab) {
    sortTab.classList.toggle("disabled", anyChecked);
  }
}
document.addEventListener('change', function (event) {
  if (event.target.classList.contains('filter-checkbox-input')) {
    updateFilterCounts();
  }
});

document.getElementById("clear-filter")?.addEventListener("click", () => {
	const collectionUrl = window.location.pathname;
    const filterUrl = `${collectionUrl}`;

    filterCollectionList(filterUrl);
    document.querySelector(".sort-by-filter").textContent = '';
});

document.getElementById("clear-all-filters")?.addEventListener("click", () => {
  // Uncheck all checkboxes in all filter groups
  document.querySelectorAll('.filter-color, .filter-category, .filter-feature')
    .forEach(input => input.checked = false);
  document.querySelectorAll('.filter-badge').forEach(badge => {
    badge.style.display = 'none';
  });
  document.querySelectorAll('.filter-badge-count').forEach(el => {
    el.textContent = '';
  });

  // Re-apply filter logic
  applyFilters();
});

document.querySelectorAll('.close-icon-btn').forEach(button => {
  button.addEventListener('click', () => {
    const filterType = button.dataset.filterType;

    // Uncheck all checkboxes of that filter group
    document.querySelectorAll(`.filter-${filterType}`).forEach(input => {
      input.checked = false;
    });

    // Hide the badge and clear count
    const badge = button.closest('.filter-badge');
    if (badge) {
      badge.style.display = 'none';
      const countSpan = badge.querySelector('span');
      if (countSpan) countSpan.textContent = '';
    }

    // Re-apply filtering
    applyFilters();
  });
});

/*** Collection List End ****/

/** sennheiser-consumer-ambassador-program iframe src start **/
$('.showIframeBtn').on('click', function () {
    $('.consumer-ambassador-iframe').toggleClass('active');
    $('body').toggleClass('consumer-ambassador-iframe-open');
});
/** sennheiser-consumer-ambassador-program iframe src end **/

// Show more button JS for collection page
document.addEventListener('click', function(e) {
  if (e.target.matches('.custom-collection-product-grid button.more-product[data-product-count-limit]')) {
    console.log("SHOW MORE CLICK");
    const hiddenItems = document.querySelectorAll('.custom-collection-product-grid .product-grid-list .product-list-card.hidden');
    hiddenItems.forEach(item => {
      item.classList.remove('hidden');
    });
    e.target.style.display = 'none';
    eqHeight();
  }
});
//End

function closeSortingDetailsMobile() {
  const detailsElements = document.querySelectorAll('.no-filter-yes-sorting .sorting-filter details[open]');
  detailsElements.forEach(el => el.removeAttribute('open'));
}

window.addEventListener('DOMContentLoaded', closeSortingDetailsMobile);
window.addEventListener('resize', closeSortingDetailsMobile);

//ACF custom pricing JS

var pricelist = getCookie("pricelist");
(() => {
  let external_price;
  let external_token;

  /** --------------------------
  * Build custom line item properties
  * -------------------------- */
  const buildCustomProperties = (external_price, external_token, pricelist) => {
    const properties = {};
    if (external_price) properties._external_price = external_price;
    if (external_token) properties._external_token = external_token;
    if (pricelist) properties._external_pricelist = pricelist;
    return properties;
  };

  /** --------------------------
  * Update cart count in header
  * -------------------------- */
  const updateCartCount = async (onReload) => {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();

      const countElem = document.querySelector('.header-actions__cart-icon .cart-bubble__text-count');
      if (countElem){
        countElem.textContent = cart.item_count;
      }else{
        document.querySelector('.header-actions__cart-icon').classList.add('header-actions__cart-icon--has-cart');
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('visually-hidden');
        document.querySelector('.header-actions__cart-icon .cart-bubble__text').innerHTML = '<span class="visually-hidden">Total items in cart:' +cart.item_count+'</span><span class="cart-bubble__text-count" aria-hidden="true">'+cart.item_count+'</span>';
      } 
      if(!onReload){
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.toggle('cart-bubble--animating');
        setTimeout(function(){
          document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('cart-bubble--animating');
        }, 300)
      }

    } catch (err) {
      console.error('❌ Error updating cart count:', err);
    }
  };

  updateCartCount(true);

  /** --------------------------
  * Bind add-to-cart events
  * -------------------------- */
  const buttons = document.querySelectorAll("product-form-component add-to-cart-component button[data-addToCartCustom]");
  if (!buttons.length) {
    console.warn('⚠️ No add-to-cart buttons found on page.');
    return;
  }

  buttons.forEach((button, index) => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();

      const form = button.closest('product-form-component');
      if (!form) {
        console.error('❌ product-form-component not found for this button');
        return;
      }

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput || !variantInput.value) {
        console.error('❌ Variant ID not found inside form');
        return;
      }

      const variant = parseInt(variantInput.value);

      if (typeof pricelist !== 'undefined' && benefits[variant] && benefits[variant][pricelist]) {
        external_price = benefits[variant][pricelist].closed_shop_price;
        external_token = benefits[variant][pricelist].closed_shop_token;
      }

      const properties = buildCustomProperties(external_price, external_token, pricelist);

      const data = {
        id: variant,
        quantity: 1,
        properties
      };

      console.log(data)
      // Perform AJAX add-to-cart
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(`HTTP ${response.status}: ${text}`);
        }

        updateCartCount();

        const responseJson = await response.json()
        let toastMessageSuffix = 'added to cart'
        if(window.Weglot && typeof Weglot.getCurrentLang === 'function') {
          const currentLang = Weglot.getCurrentLang();
          if(currentLang === "fr-ca") {
            toastMessageSuffix = 'ajouté au panier'
          }
        }
        document.dispatchEvent(new CustomEvent('ShowToast', {
          detail: {
            titleText: `${responseJson.product_title} ${toastMessageSuffix}`
          }
        }));

      } catch (error) {
        console.error('❌ Error adding to cart:', error);
      }
    });
  });
})();


if (pricelist != undefined) {
  var c_variant_id;
  if(document.querySelector('.pdp-main-wrapper')){
    c_variant_id = parseFloat(document.querySelector('.pdp-main-wrapper product-form-component form.shopify-product-form input[name=id]').value);
  }else if(document.querySelector('.custom-pdp-two-col-section')){
    c_variant_id = parseFloat(document.querySelector('.custom-pdp-two-col-section product-form-component form.shopify-product-form input[name=id]').value);
  }
  
  for (var prop in benefits) {
    var closed_shop = benefits[prop][pricelist];
    if (closed_shop != undefined) {
      
      var money_formatted = formatMoney(closed_shop.closed_shop_price, theme.moneyFormat);
      var compare_at_price_formatted = formatMoney(closed_shop.compare_price, theme.moneyFormat);
      
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-compare-price]').forEach(el => {
        el.innerText = compare_at_price_formatted;
      });
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-actual-price]').forEach(el => {
        el.innerText = money_formatted;
      });
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-compare-price]').forEach(el => {
        el.style.removeProperty('display');
      });
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"]').forEach(el => {
        const next = el.nextElementSibling;
        if (!next || !next.classList.contains('promotional-price')) {
          el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
        }
      });
      
      if(prop == c_variant_id){
        document.querySelectorAll(".closed_shop_price").forEach(el => {
          el.value = closed_shop.closed_shop_price;
          el.disabled = false;
        });
        document.querySelectorAll(".closed_shop_token").forEach(el => {
          el.value = closed_shop.closed_shop_token;
          el.disabled = false;
        });

        document.querySelectorAll(".closed_shop_pricelist").forEach(el => {
          el.value = pricelist;
          el.disabled = false;
        });
      }

    }
  }
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
  

var display_price = function(current_variant_id, isPDP) {
  var variant_id = getUrlParameter("variant");
  if (variant_id == undefined) {
    variant_id = current_variant_id;
  }
  var variant = benefits[variant_id];
  if (variant != null && variant != undefined) {
    var pricelist = getCookie("pricelist");
    var closed_shop = variant[pricelist];

    document.querySelectorAll(".closed_shop_pricelist").forEach(el => {
      el.value = pricelist;
      el.disabled = false;
    });

    if (closed_shop != null && closed_shop != undefined) {
      
      var money_formatted = formatMoney(closed_shop.closed_shop_price, theme.moneyFormat);
      var compare_at_price_formatted = formatMoney(closed_shop.compare_price, theme.moneyFormat);

      if(isPDP){
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-compare-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-compare-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-compare-price]').forEach(el => {
            el.innerText = compare_at_price_formatted;
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-actual-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-actual-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-actual-price]').forEach(el => {
            el.innerText = money_formatted;
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-compare-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-compare-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-compare-price]').forEach(el => {
            el.style.removeProperty('display');
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id], .pdp-top-sticky-bar .product-price[data-variant-id], .custom-pdp-two-col-section .product-price[data-variant-id]').forEach(el => {
            const next = el.nextElementSibling;
            if (!next.classList.contains('promotional-price')) {
              el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
            }
          });

          document.querySelectorAll(".closed_shop_price").forEach(el => {
            el.value = closed_shop.closed_shop_price;
            el.disabled = false;
          });
          document.querySelectorAll(".closed_shop_token").forEach(el => {
            el.value = closed_shop.closed_shop_token;
            el.disabled = false;
          });
      } else {
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-compare-price]').forEach(el => {
            el.innerText = compare_at_price_formatted;
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-actual-price]').forEach(el => {
            el.innerText = money_formatted;
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-compare-price]').forEach(el => {
            el.style.removeProperty('display');
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"]').forEach(el => {
            const next = el.nextElementSibling;
            if (!next || !next.classList.contains('promotional-price')) {
              el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
            }
          });
      }
    }
  }
}
// END

/**Show cookie sidebar by cooking setting btn click start **/
document.getElementById('cookie-settings').addEventListener('click', function (e) {
  e.preventDefault();
  if (window.OneTrust) {
    OneTrust.ToggleInfoDisplay();
  } else {
    console.warn('OneTrust not found.');
  }
});
/**Show cookie sidebar by cooking setting btn click end **/


// // Default language settings start--- 
//   window.addEventListener("pageshow", function (event) {

//     const selectCountry = document.getElementById("country-select");

//     selectCountry.value = "TW";
// });
//  document.addEventListener("DOMContentLoaded", function () {
//     const select = document.getElementById("language-select");
//     if (!select) return;

//    setTimeout(function() {
//     if (Weglot.getCurrentLang() == 'en') {
//       select.value = "en";
//       // document.querySelectorAll('.japanese-section .japanese-only-section')
//       //     .forEach(el => {
//       //       el.style.display = 'none';
//       //     });

//      // document.getElementById('japanese-only-section').style.display = 'none';
//     } else if(Weglot.getCurrentLang() == 'zh-tw'){
//       select.value = "zh-tw";
//       // document.querySelectorAll('.japanese-section .japanese-only-section')
//       //     .forEach(el => {
//       //       el.style.display = 'block';
//       //     });
      
//     //  document.getElementById('japanese-only-section').style.display = 'block';
//     }}
//     , 2000);
//   });


  //Show More on Similar Products
  function showMoreProducts() {
    document.getElementById('more-products').style.display = 'flex';
    document.getElementById('show-more-button').style.display = 'none';
  }

/* canvas images */
function productrotation() {
  console.log("productrotation");
  const canvases = document.querySelectorAll(".product360Canvas");
 
  canvases.forEach((canvas) => {
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
 
    const productNumber = canvas.dataset.product || "1";
    const frameCount = parseInt(canvas.dataset.framecount, 10) || 1;
    const imageBase = canvas.dataset.imageurl;

    console.log(imageBase);
 
    const images = [];
    let currentFrame = 0;
    let isDragging = false;
    let startX = 0;
   
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      const fileimage = '//sennheiser-pim.myshopify.com/cdn/shop/files/0_267.webp?v=3841086156881147033';
      const fileimage2 =  "//sennheiser-pim.myshopify.com/cdn/shop/files/";
      //img.src = `${fileimage2}0_${i + 1}.webp`;
      img.src = `${imageBase}0_${i + 1}.webp`;
      //console.log("image src", img.src);
      //img.src = `canvas-images/product${productNumber}/0_${i + 1}.webp`;
      images.push(img);
    }
 
    images[0].onload = function () {
      ctx.drawImage(images[0], 0, 0, canvas.width, canvas.height);
    };
 
    function drawFrame(frameIndex) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(images[frameIndex], 0, 0, canvas.width, canvas.height);
    }
 
    canvas.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.pageX;
    });
 
    canvas.addEventListener("mouseup", () => {
      isDragging = false;
    });
 
    canvas.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
 
      let delta = e.pageX - startX;
      const sensitivity = 1;
 
      if (Math.abs(delta) > 1) {
        const framesToMove = Math.floor(Math.abs(delta) * sensitivity);
 
        currentFrame =
          delta > 0
            ? (currentFrame - framesToMove + frameCount) % frameCount
            : (currentFrame + framesToMove) % frameCount;
 
        drawFrame(currentFrame);
        startX = e.pageX;
      }
    });
  });
}
window.addEventListener("DOMContentLoaded", productrotation);

/*M5 launch - sign up form class js starts */
document.addEventListener("DOMContentLoaded", function () {
  console.log("JS Loaded");

  const ctaButton = document.querySelector('.custom-countdown-slide-btn');

  console.log("CTA Button:", ctaButton);

  if (!ctaButton) return;

  // Get current Weglot language
  const currentLang =
    typeof Weglot !== "undefined"
      ? Weglot.getCurrentLang().toLowerCase()
      : "en";

  console.log("Current Lang:", currentLang);

  // Dynamic language class mapping
  const langClassMap = {
      'en': 'hs-cta-trigger-button-395281377490',      
      'de': 'hs-cta-trigger-button-395411473650',      
      'fr': 'hs-cta-trigger-button-404548245700',      
      'nl': 'hs-cta-trigger-button-404548518134',      
      'hu': 'hs-cta-trigger-button-404548519141',     
      'it': 'hs-cta-trigger-button-404548519153',     
      'pt': 'hs-cta-trigger-button-404550840547',      
      'es': 'hs-cta-trigger-button-404550841538',      
      'zh': 'hs-cta-trigger-button-404549540056',      
      'zh-hk': 'hs-cta-trigger-button-404549540089',  
      'ja': 'hs-cta-trigger-button-404549541059',      
      'zh-tw': 'hs-cta-trigger-button-404549541077', 
      'th': 'hs-cta-trigger-button-404549541084',      
      'ar': 'hs-cta-trigger-button-404549542078',     
      'vi': 'hs-cta-trigger-button-404549544158'    
    };
    

  // Add common class
  ctaButton.classList.add("hs-cta-trigger-button");


  // Remove all previous lang classes
  Object.values(langClassMap).forEach((className) => {
    ctaButton.classList.remove(className);
  });

  console.log("Old lang classes removed");


  // Add dynamic lang class
  if (langClassMap[currentLang]) {
    ctaButton.classList.add(langClassMap[currentLang]);
  }

  console.log("Updated Classes:", ctaButton.className);
});
/*M5 launch - sign up form class js ends */

/* 19-05-26 : M5 Exp Page Signup Form Start */
document.addEventListener("DOMContentLoaded", () => {
  const ctaButtons = document.querySelectorAll(".m5-hubspot-form-cta");

  if (!ctaButtons.length) return;

  const langClassMap = {
    en: "hs-cta-trigger-button-395281377490",
    de: "hs-cta-trigger-button-395411473650",
    fr: "hs-cta-trigger-button-404548245700",
    nl: "hs-cta-trigger-button-404548518134",
    hu: "hs-cta-trigger-button-404548519141",
    it: "hs-cta-trigger-button-404549519153",
    pt: "hs-cta-trigger-button-404550840547",
    es: "hs-cta-trigger-button-404550841538",
    zh: "hs-cta-trigger-button-404549540056",
    "zh-hk": "hs-cta-trigger-button-404549540089",
    ja: "hs-cta-trigger-button-404549541059",
    "zh-tw": "hs-cta-trigger-button-404549541077",
    th: "hs-cta-trigger-button-404549541084",
    ar: "hs-cta-trigger-button-404549542078",
    vi: "hs-cta-trigger-button-404549544158"
  };

  const CTA_CLASS_PREFIX = "hs-cta-trigger-button-";

  function getCurrentLanguage() {
    if (
      typeof Weglot !== "undefined" &&
      typeof Weglot.getCurrentLang === "function"
    ) {
      return (Weglot.getCurrentLang() || "en").toLowerCase();
    }

    return "en";
  }

  function updateCTAButton() {
    const currentLang = getCurrentLanguage();
    const langClass = langClassMap[currentLang];

    ctaButtons.forEach((button) => {
      button.className = button.className
        .split(" ")
        .filter((cls) => !cls.startsWith(CTA_CLASS_PREFIX))
        .join(" ");

      button.classList.add("hs-cta-trigger-button");

      if (langClass) {
        button.classList.add(langClass);
      }
    });
  }

  updateCTAButton();

  if (typeof Weglot !== "undefined" && typeof Weglot.on === "function") {
    Weglot.on("languageChanged", updateCTAButton);
  }
});
/* 19-05-26 : M5 Exp Page Signup Form End */
document.addEventListener('DOMContentLoaded', function () {
    const video = document.getElementById('mtw5-slide-desk');
    const mobVideo = document.getElementById('mtw5-slide-mob');
    const source = document.getElementById('mtw5-slide-desk-video-source');
    const mobSource = document.getElementById('mtw5-slide-mob-video-source');

    if (!video || !source) return;

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Detect Apple devices
    const isIOS =
        /iPad|iPhone|iPod/.test(userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    const isMacOS = /Macintosh/.test(userAgent);

    // Apple devices → HEVC MP4
    if (isIOS || isMacOS) {
        source.src = source.dataset.hevc;
        source.src = 'https://cdn.shopify.com/videos/c/o/v/16ac47700db142c19e8a9ad7720dbc06.mp4';
        source.type = 'video/mp4';
        mobSource.src = mobSource.dataset.hevc;
        mobSource.src = 'https://cdn.shopify.com/videos/c/o/v/08f92aafccca4a6db2d0b2b2af6dd569.mp4';
        mobSource.type = 'video/mp4';
    }
    // Windows / Android / other devices → WebM
    else {
        source.src = source.dataset.webm;
        source.src = 'https://cdn.shopify.com/videos/c/o/v/7e2fcc310986484ea2f32a29e4bb3906.webm';
        source.type = 'video/webm';
        mobSource.src = mobSource.dataset.hevc;
        mobSource.src = 'https://cdn.shopify.com/videos/c/o/v/c59975a4485d4a15acc559264a40b859.webm';
        mobSource.type = 'video/webm';
    }

    video.load();
    mobVideo.load();
});